import React from 'react';
import exportAsPDF from '../utils/exportAsPDF';

interface ShareOptionsProps {
  qrCodeUrl: string; // The QR code image URL
}

const ShareOptions: React.FC<ShareOptionsProps> = ({ qrCodeUrl }) => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = qrCodeUrl;
    link.download = 'qr-code.png';
    link.click();
  };

  const handleShareToWhatsApp = () => {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
      'Check out this QR code: ' + qrCodeUrl
    )}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleShareToFacebook = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      qrCodeUrl
    )}`;
    window.open(facebookUrl, '_blank');
  };
  const handleDownloadPDF = () => {
    exportAsPDF(qrCodeUrl);
  };

  return (
    <div>
      <h3>Share Your QR Code:</h3>
      <button onClick={handleDownload}>Download as Image</button>
      <button onClick={handleShareToWhatsApp}>Share to WhatsApp</button>
      <button onClick={handleDownloadPDF}>Download as PDF</button>
      {/* <button onClick={handleShareToFacebook}>Share to Facebook</button> */}
    </div>
  );
};

export default ShareOptions;